import {
    useToggleArchiveSocialBenefitMutation,
    useCreateSocialBenefitMutation,
    useGetArchivedPaginatedSocialBenefitsMutation,
    useGetPaginatedSocialBenefitsMutation,
    useUpdateSocialBenefitMutation,
} from '@services/member/list/social-benefits/social-benefits.endpoints';
import { SocialBenefit } from '@services/member/list/social-benefits/social-benefits.types';
import { useState, useMemo, useEffect } from 'react';
import { PaginationMetadata } from '@services/providers/cosem.types';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

export const useSocialBenefitsPageVM = () => {
    const [totalSocialBenefits, setTotalSocialBenefits] = useState<number>(0);
    const [isArchived, setIsArchived] = useState<boolean>(false);
    const [needReload, setNeedReload] = useState<boolean>();
    const MySwal = withReactContent(Swal);

    const [
        updateSocialBenefit,
        {
            isSuccess: isUpdateSocialBenefitSuccess
        }
    ] = useUpdateSocialBenefitMutation();

    const [
        createSocialBenefit,
        {
            isSuccess: isCreateSocialBenefitSuccess
        }
    ] = useCreateSocialBenefitMutation();

    const [
        toggleArchiveSocialBenefit,
        {
            isSuccess: isToggleArchiveSocialBenefitSuccess
        }
    ] = useToggleArchiveSocialBenefitMutation();

    const handleArchiveSocialBenefits = async (lines: SocialBenefit[], archive: boolean) => {
        MySwal.fire({
            title:
                lines.length === 1
                    ? archive ? 'Êtes-vous sûr de vouloir archiver ce type de prestation sociale ?' : 'Êtes-vous sûr de vouloir désarchiver ce type de prestation sociale ?'
                    : archive ? 'Êtes-vous sûr de vouloir archiver ces types de prestations sociales ?' : 'Êtes-vous sûr de vouloir désarchiver ces types de prestations sociales ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#01539D',
            confirmButtonColor: '#01539D',
            confirmButtonText: archive ? 'Archiver' : 'Désarchiver',
            cancelButtonColor: '#FF5F46',
            cancelButtonText: 'Annuler'
        }).then(async (result) => {
            if (result.isConfirmed) {
                lines.forEach((line) => {
                    toggleArchiveSocialBenefit({ id: line.id, archived: archive });
                });
            }
        });
    };

    useEffect(() => {
        if(isCreateSocialBenefitSuccess || isUpdateSocialBenefitSuccess || isToggleArchiveSocialBenefitSuccess) {
            setNeedReload((prev) => !prev);
        }
    }, [isCreateSocialBenefitSuccess, isUpdateSocialBenefitSuccess, isToggleArchiveSocialBenefitSuccess]);

    
    const mutationHook = useMemo(() => {
        return isArchived ? useGetArchivedPaginatedSocialBenefitsMutation : useGetPaginatedSocialBenefitsMutation;
    }, [isArchived]);

    useEffect(() => {
        setTotalSocialBenefits(0);
    }, [isArchived]);

    const handleMetadata = (metadata: PaginationMetadata) => {
        if (metadata && metadata.total !== undefined) {
            setTotalSocialBenefits(metadata.total);
        }
    };

    return {
        mutationHook,
        totalSocialBenefits,
        setTotalSocialBenefits,
        isArchived,
        handleMetadata,
        handleArchiveSocialBenefits,
        needReload,
        MySwal,
        createSocialBenefit,
        updateSocialBenefit,
        setIsArchived
    };
};
